import { render, staticRenderFns } from "./commDetails.vue?vue&type=template&id=f52e55d8&"
import script from "./commDetails.vue?vue&type=script&lang=js&"
export * from "./commDetails.vue?vue&type=script&lang=js&"
import style0 from "./commDetails.vue?vue&type=style&index=0&id=f52e55d8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports